import { useMemo } from 'react';

import { useStatusContext } from 'pages/Status/context';

export type PaidByBankView = 'accepted' | 'finished' | 'satnote';

interface PaidByCardHook {
  variant: PaidByBankView;
}

export default function usePaidByCard(): PaidByCardHook {
  const { job, isLoading } = useStatusContext();

  const variant = useMemo(() => {
    if (!job || isLoading) return 'accepted';
    const { status } = job;
    if (!status || status === 'accepted') return 'accepted';
    const satNote = Boolean(job?.sat_note);
    if (status === 'finished' && !satNote) return 'satnote';
    return 'finished';
  }, [job, isLoading]);

  return {
    variant,
  };
}
